<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
import comMapping from '../../../../../comMapping';
import configHttp from "../../../../../../configHttp";
export default {
	props: {
		activeName: {
			type: String,
			default: '0'
		}
	},
	data() {
		return {
			comMapping: comMapping,
			//表格筛选
			shaidiag: false,
			headData: JSON.parse(localStorage.getItem('../components/page/AllelectricInvoice/ManualExportAndImport/DataToBeOpened')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('../components/page/AllelectricInvoice/ManualExportAndImport/DataToBeOpened')) || [],
			//表格搜索
			searchlist: getdata().searchlist,
			searchdata: getdata().searchdata,
			//表格
			tableHeight: null,
			tableData: [],
			pagination: getdata().pagination,
			tablekey: 0,
			activeName: '1',
			value1: '',
			activeName: '0',
			//排序字段名称
			order: '',
			//排序顺序
			sort: ''
		};
	},
	watch: {
		activeName: function(indexVal, oldVal) {
			this.$emit('active', indexVal);
		}
	},
	created() {
	},
	mounted() {
		this.DataQuery();
	},
	methods: {
		//导出
		Export() {
			if (this.$refs.tablebox.getSelectionval().length == 0) {
				this.$message.error('请选择数据');
				return;
			}
			for (var i = 0; i < this.$refs.tablebox.getSelectionval().length; i++) {
				if (this.$refs.tablebox.getSelectionval()[i].fapzt != '1') {
					this.$message.error('只能导出以审核的数据');
					return;
				}
			}
			let params = { ids: this.$refs.tablebox.getSelectionval().map(v => v.id) };
			this.$https.fetchdowload('felec/manual/manualExport', params).then(res => {
				const content = res.data;
				const blob = new Blob([content]);
				var date = new Date().getFullYear() + '' + (new Date().getMonth() + 1) + '' + new Date().getDate();
				var companyName = JSON.parse(localStorage.getItem('useropj')).currCompany.name;
				const fileName = companyName + date + '.xls';
				if ('download' in document.createElement('a')) {
					// 非IE下载
					const elink = document.createElement('a');
					elink.download = fileName;
					elink.style.display = 'none';
					elink.href = URL.createObjectURL(blob);
					document.body.appendChild(elink);
					elink.click();
					URL.revokeObjectURL(elink.href); // 释放URL 对象
					document.body.removeChild(elink);
				} else {
					// IE10+下载
					navigator.msSaveBlob(blob, fileName);
				}
				this.DataQuery();
			});
		},
		//排序
		sortchange(e) {
			console.log(e);
			this.order = e.prop;
			if (e.order == 'ascending') {
				this.sort = 'ASC';
			} else if (e.order == 'descending') {
				this.sort = 'DESC';
			} else {
				this.sort = '';
			}
			this.DataQuery();
		},

		//代开数据 结果回写表格数据查询
		DataQuery() {

      //todo 需要加双日判断
      if (configHttp.shuangRiTaxNumber) {
        let shuangRiTaxNumber = configHttp.shuangRiTaxNumber;
        let userobj = JSON.parse(localStorage.getItem('useropj'));
        let qiybh = userobj.currCompany.code;
        if (shuangRiTaxNumber.includes(qiybh)) {
          this.searchdata.fapzl = "2";
          this.searchdata.cank1 = "3";
        }
      }

			let patea = {
				limit: this.pagination.pageSize,
				page: this.pagination.pageNum,
				order: this.order,
				sort: this.sort,
				param: JSON.parse(JSON.stringify(this.searchdata))
			};
			this.$https.fetchPost('felec/manual/getDocList/toBeInvoiced', patea).then(res => {
				if (res.data.code == '200') {
					this.pagination.total = res.data.count;
					this.tableData = res.data.data.map(v => {
						if (v.danjrq != null) {
							if (v.danjrq.length == 8) {
								var reg = /^(\d{4})(\d{2})(\d{2})$/;
								v.danjrq = v.danjrq.replace(reg, '$1年$2月$3日');
							} else if (v.danjrq.length == 14) {
								var reg = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/;
								v.danjrq = v.danjrq.replace(reg, '$1年$2月$3日');
							}
						}
						return v;
					});
					this.$nextTick(()=>{
							this.$refs.tablebox.doout();
					})

				} else {
					this.$message.error('失败');
				}
			});
		},
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('../components/page/AllelectricInvoice/ManualExportAndImport/DataToBeOpened', JSON.stringify(e.nochooselist));
			localStorage.setItem('../components/page/AllelectricInvoice/ManualExportAndImport/DataToBeOpened', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
		},
		//表格搜索
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.DataQuery();
		},
		//表格分页
		sizechange(e) {
			this.pagination.pageSize = e;
			this.DataQuery();
		},
		currentChange(e) {
			this.pagination.pageNum = e;
			this.DataQuery();
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
